import React from "react";
import "./Copyright.scss";
import { APP_NAME } from "../../../_assets/branding";

/**
 * Reusable Copyright component
 * @param {Object} props - Component props
 * @param {string} [props.text] - Copyright text to display (defaults to `© ${APP_NAME}`)
 * @param {string} [props.className=""] - Additional CSS classes
 * @param {Object} [props.style={}] - Additional inline styles
 * @returns {JSX.Element} Copyright component
 */
const Copyright = ({ text = `© ${APP_NAME}`, className = "", style = {} }) => {
  return (
    <div className={`copyright-container ${className}`} style={style}>
      {text}
    </div>
  );
};

export default Copyright;
